<template>
  <div
    :class="{
      'has-logo': showLogo,
      'has-store-tabs': sellerServerStoreStatus == 1,
    }"
  >
    <operation-guide
      v-if="isShowGuide"
      :index="showGuideIndex"
      @goNext="goNextGuide"
    />
    <logo
      v-if="showLogo"
      :collapse="isCollapse"
      :class="{ 'guide-hide': isShowGuide }"
    />
    <div
      v-if="sellerServerStoreStatus == 1"
      class="c-menu-type"
      :class="{ 'has-radio': !isCollapse, 'guide-hide': isShowGuide }"
    >
      <el-radio-group :value="sellerBookingType" @change="toggleMenuType">
        <el-radio-button
          class="has-radio-button has-radio-left"
          :class="{
            'has-radio-left-active': !radioActive,
            'has-radio-active': !radioActive,
          }"
          :label="0"
        >
          直邮商城
        </el-radio-button>
        <el-radio-button
          class="has-radio-button has-radio-right"
          :class="{
            'has-radio-right-active': radioActive,
            'has-radio-active': radioActive,
          }"
          :label="1"
        >
          门店自提
        </el-radio-button>
      </el-radio-group>
    </div>

    <el-scrollbar
      v-if="sellerBookingType == 0 && !accountType.includes(4)"
      wrap-class="scrollbar-wrapper"
    >
      <el-menu
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
        @open="handleOpen"
        @close="handleClose"
      >
        <sidebar-item
          v-for="(route, i) in routes"
          :key="route.path"
          :class="{
            'guide-show': isShowGuide && showGuideIndex === i - guideFrom,
          }"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <el-scrollbar
      v-else-if="sellerBookingType == 1 && !accountType.includes(4)"
      wrap-class="scrollbar-wrapper scrollbar-wrapper-white"
    >
      <el-menu
        :collapse="isCollapse"
        background-color="#fff"
        text-color="#666"
        :unique-opened="false"
        active-text-color="#666"
        :collapse-transition="false"
        mode="vertical"
        @open="handleOpen"
        @close="handleClose"
      >
        <sidebar-item
          v-for="route in pickupRoutes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <el-scrollbar v-else wrap-class="scrollbar-wrapper">
      <el-menu
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
        @open="handleOpen"
        @close="handleClose"
      >
        <sidebar-item
          v-for="(route, i) in supplierRoutes"
          :key="route.path"
          :class="{
            'guide-show': isShowGuide && showGuideIndex === i - guideFrom,
          }"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.scss';
import { hasAuthMenu, filterStoreAuthMenu, supplierMenu } from '@/permission';

export default {
  components: {
    SidebarItem,
    Logo,
    'operation-guide': () => import('@/components/operation-guide/guide.vue'),
  },
  data() {
    return {
      showGuideIndex: 0,
    };
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'accountType',
      'sellerBookingType',
      'isShowGuide',
      'sellerServerStoreStatus',
    ]),
    routes() {
      // 权限过滤,跟判断权限不一样,如果有子集就显示父级
      let temp = _.cloneDeep(this.$router.options.routes);
      temp = temp.filter(to => {
        // 没有设置name属性的不会体现在菜单栏中
        if (!to.name) return;
        // 是否有2级菜单权限
        to.children = to.children?.filter(k => hasAuthMenu(k));
        return to.children?.length;
      });
      return temp;
    },
    pickupRoutes() {
      // 自提业务路由
      let temp = _.cloneDeep(this.$router.options.routes);
      temp = temp.filter(to => {
        // 没有设置name属性的不会体现在菜单栏中
        if (!to.name) return;
        // 是否有2级菜单权限
        to.children = to.children?.filter(k => filterStoreAuthMenu(k));
        return to.children?.length;
      });

      return temp;
    },
    // 供应商菜单
    supplierRoutes() {
      // 自提业务路由
      let temp = _.cloneDeep(this.$router.options.routes);
      temp = temp.filter(to => {
        // 没有设置name属性的不会体现在菜单栏中
        if (!to.name) return;
        // 是否有2级菜单权限
        to.children = to.children?.filter(k => supplierMenu(k));
        return to.children?.length;
      });

      return temp;
    },

    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      return meta.activeMenu;
      // }
      // return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },

    radioActive() {
      return this.sellerBookingType != 0;
    },
    guideFrom() {
      const temp = _.cloneDeep(this.routes);
      let index = 0;
      temp.forEach(r => {
        if (r.name === 'shop-situation' && r.children.length > 0) {
          index++;
        }
      });
      console.log(index, 'guideFrom');
      return index > 0 ? 1 : 0; // 怕重复
    },
  },
  methods: {
    goNextGuide() {
      if (this.showGuideIndex < 5) {
        this.showGuideIndex++;
        return;
      }
      this.$store.dispatch('app/setGuideShow', false);
    },
    toggleMenuType() {
      this.$store.dispatch('app/toggleBusinessType');
      this.$router.push({
        path: '/home',
      });

      // 切换tab样式
      // this.radioActive = this.sellerBookingType != 0;
    },
    handleOpen(r, b) {
      // todo 适配所有的存在路由视图的展开
      if (r.includes('marketing-campaign')) {
        this.$router.push({
          name: 'marketing-campaign',
        });
      }
    },
    handleClose(r, b) {
      // todo 适配所有的存在路由视图的展开
      if (r.includes('marketing-campaign')) {
        this.$router.push({
          name: 'marketing-campaign',
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .scrollbar-wrapper-white {
    background: #fff;
    border-right: 1px solid #ddd;

    .el-scrollbar__view .el-menu {
      background: #fff;
    }
  }

  // .scrollbar-wrapper-white > .el-scrollbar__view > .el-menu > div{
  //     .is-active > .el-submenu__title > span {
  //       color: rgb(102, 102, 102) !important;
  //     }
  // }

  .has-radio {
    background-color: #fff !important;
    padding-top: 6px !important;
    padding-bottom: 0px !important;

    div {
      position: relative;
      width: 100%;
      height: 43px;
    }

    .el-radio-button__inner {
      position: absolute;
      display: inline-block;
      border-radius: 0px !important;
      bottom: 0px;
      width: 105px;
      border-color: #304156 !important;
      box-shadow: none !important;
    }

    .has-radio-button {
      position: absolute !important;
      height: 43px;

      input {
        right: 0px;
      }
    }

    .has-radio-right {
      right: 0px;

      .el-radio-button__inner {
        background-color: #ffffff;
        color: #304156;
        right: 0px;
      }
    }

    .has-radio-left {
      left: 0px;

      .el-radio-button__inner {
        background-color: #304156;
        color: #ffffff;
        left: 0px;
      }
    }

    .has-radio-active {
      .el-radio-button__inner {
        width: 125px;
        height: 43px;
        z-index: 1;
        line-height: 25px;
      }
    }

    .has-radio-left-active {
      .el-radio-button__inner {
        border-top-right-radius: 100px !important;
      }
    }

    .has-radio-right-active {
      .el-radio-button__inner {
        border-top-left-radius: 100px !important;
      }
    }
  }

  .hideSidebar {
    .has-radio {
      display: none;
    }
  }
}

.c-menu-type {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.guide-hide {
  opacity: 0.5;
  background: #000000;
  border: none;
  z-index: inherit;
}
.guide-show {
  border: solid 1px #fff;
  margin-right: 1px;
  z-index: 9999;
  opacity: 1;
  background: transparent;
}
</style>
